import type { RouteObject } from "react-router-dom";
import Credentials from "@/pages/credentials";

export const credentialsRoutes: RouteObject[] = [
  { path: "/credentials", element: <Credentials /> },
];
